import React, { useEffect, useState } from 'react';
import getSupplierColumn from './SupplierListGridConfig';
import getSupplierColumnContactDetails from './ContactDetailsSuppliersGridConfig';
import readXlsxFile from 'read-excel-file';
import { useLocation, useNavigate } from 'react-router-dom';
import CommonTable from '../../Shared/Tables';
import APIService from '../../../Services/APIService';

const SupplierList = (props) => {
  const { token } = props.auth;
  const location = useLocation();
  const navigate = useNavigate();
  const [isCampaign, setIsCampaign] = useState(true)
  const [name, setName] = useState('')
  const [supplierDetails, setSupplierDetails] = useState([])
  const [suppliersData, setSuppliersData] = useState([])
  const [columns, setColumns] = useState([])
  const [pageData, setPageData] = useState({})

  const getSupplierDetails = async (data) => {
    let res = await APIService.post(`/v0/ui/website/multi-supplier-details/`, data);
    if (res.status == 200)
      setSupplierDetails(res.data)
  };

  useEffect(() => {
    setPageData(location.state)
    let {
      suppliers,
      names,
      is_multiple_contact_name,
      is_multiple_contact_number,
      is_contact_name,
      is_contact_number,
      isCampaigns,
      supplier_type_code,
    } = location.state || pageData;

    if (isCampaigns === false) setIsCampaign(isCampaigns);
    if (!supplier_type_code) supplier_type_code = 'RS';
    setName(names);
    if (suppliers && typeof suppliers[0] == 'string') {
      const data = {
        supplier_ids: suppliers,
        supplier_type_code,
        is_multiple_contact_name: is_multiple_contact_name || false,
        is_multiple_contact_number: is_multiple_contact_number || false,
        is_contact_name: is_contact_name || false,
        is_contact_number: is_contact_number || false,
      };
      getSupplierDetails(data);
      setColumns(getSupplierColumnContactDetails())
    } else {
      setSupplierDetails(suppliers)
      setColumns(getSupplierColumn())
    }
  }, [])

  const fetchSupplierData = async (fileData) => {
    let res = await APIService.post(`/v0/ui/website/update-supplier-data/`, fileData);
    if (res.status == 200)
      setSuppliersData(res.data)
  };

  const fileUpload = (e) => {
    var fileSelect = e.target.files[0];

    readXlsxFile(fileSelect).then((rows) => {
      let fileData = [];
      if (rows && rows.length > 1) {
        let header = rows[0];
        for (var i = 1; i < rows.length; i++) {
          var obj = {};
          var currentline = rows[i];
          for (var j = 0; j < header.length; j++) {
            obj[header[j]] = currentline[j];
          }
          fileData.push(obj);
        }
      }
      // return JSON.stringify(fileData);
      fetchSupplierData(fileData);
    });
  }

  let { status = '', type } = pageData;
  let path, title, headerValue, heading;
  status = status ? status.charAt(0).toUpperCase() + status.slice(1) : '';
  path = `/r/operations-dashboard/entity`;
  headerValue = `List of ${name} (${type})`;
  title = `Entity `;
  heading = status ? `${name} (${status.toUpperCase()})` : `${name} (${type})`;

  if (isCampaign) {
    path = `/r/operations-dashboard`;
    title = 'Campaign Name';
    headerValue = 'List of Entities';
  }

  return (
    <div className="bootstrap-iso">
      <button
        type="button"
        className="btn btn-danger"
        onClick={() => navigate(path)}
        style={{ marginTop: '10px', backgroundColor: '#e84478', borderColor: '#e84478' }}
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
        &nbsp; Back
      </button>
      <span className="pull-right">
        <label>Upload Supplier Excel </label> &nbsp;
        <input type="file" id="upload_file" onChange={(e) => fileUpload(e)} />
      </span>
      {isCampaign && (
        <div style={{ fontStyle: 'oblique', textAlign: 'center' }}>
          <h5
            style={{
              color: '#6d6d6d',
            }}
          >
            {title} :
          </h5>
          <h5
            style={{
              color: 'rgb(0, 114, 196)',
            }}
          >
            {heading}
          </h5>
        </div>
      )}
      {supplierDetails && supplierDetails.length > 0 && (
        <CommonTable
          id={'campaign_id'}
          columnsData={columns}
          rowData={supplierDetails} />
      )}
    </div>
  );
}


export default SupplierList;
